(() => {
  const header = document.querySelector('header.header-section');
  if (!header) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  let scheduled = false;

  const update = () => {
    const scrollTop = Math.max(window.scrollY, pageWrapper?.scrollTop || 0);
    header.classList.toggle('sp-header-scrolled', scrollTop > 12);
    scheduled = false;
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  pageWrapper?.addEventListener('scroll', scheduleUpdate, { passive: true });
})();
